var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateDbIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 23.7286H20.8214V19.6143H0.25V23.7286ZM2.30714 20.6429H4.36429V22.7001H2.30714V20.6429ZM0.25 7.27148V11.3858H20.8214V7.27148H0.25ZM4.36429 10.3572H2.30714V8.30006H4.36429V10.3572ZM0.25 17.5572H20.8214V13.4429H0.25V17.5572ZM2.30714 14.4715H4.36429V16.5286H2.30714V14.4715Z",
    fill: "#1A96F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8.92857H26.5V8.42857V6.57143V6.07143H26H20.9286V1V0.5H20.4286H18.5714H18.0714V1V6.07143H13H12.5V6.57143V8.42857V8.92857H13H18.0714V14V14.5H18.5714H20.4286H20.9286V14V8.92857H26Z",
    fill: "#1A96F0",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDbIcon);
export default __webpack_public_path__ + "static/media/CreateDBIcon.14660002bfbb4083bef4bc57007c762b.svg";
export { ForwardRef as ReactComponent };